function Footer() {
  return (
    <footer className="flex text-center px-4 py-8 justify-center">
      <p className="text-sm">
        Copyright 2025 • All Rights Reserved LuxSpace by AneefDev
      </p>
    </footer>
  );
}

export default Footer;